import { createAction } from '@ngrx/store';
import { CartItem } from '../../interfaces/cart.interface';

// Die ngrx Actions definieren die Aktionen, die von der Anwendung ausgelöst werden können, um den Zustand des Warenkorbs (Cart) zu ändern.

export const AddCartItem = createAction(
  '[CART] ADD_CART_ITEM',
  (payload: CartItem) => payload
);

export const RemoveCartItem = createAction(
  '[CART] REMOVE_CART_ITEM',
  (payload: CartItem) => payload
);

export const UpdateCartItem = createAction(
  '[CART] UPDATE_CART_ITEM',
  (payload: { item: CartItem; didAddProduct: boolean }) => payload
);

export const EmptyCart = createAction('[CART] EMPTY_CART');

export const BatchAddCartItem = createAction(
  '[CART] BATCH_ADD_CART_ITEM',
  (payload: { items: CartItem[] }) => payload
);

export const BatchUpdateCartItem = createAction(
  '[CART] BATCH_Update_CART_ITEM',
  (payload: { items: CartItem[]; didAddProduct: boolean }) => payload
);
